export default function parseDecimal(value: string | null | undefined): number | undefined {
  const cleanValue = value?.replaceAll(" ", "").replaceAll(",", ".");
  if (cleanValue && /^[-+]?[1-9]\d*(\.{1}\d*)?$|^0$/.test(cleanValue)) {
    return parseFloat(cleanValue);
  }
  return undefined;
}
